import React from "react";
import Sidebar from "../../components/Super Admin/SideBar/Sidebar";
import Topbar from "../../components/Super Admin/TopBar/TopbarCenterManagement";
import EditAppointmentsTable from "../../components/Super Admin/Center Management/EditAppointmentsTable";
import "../../css/AddStationsPage.css";

const EditAppointmentPage: React.FC = () => {
  return (
    <>
        <Topbar />
        <EditAppointmentsTable />
    </>
  );
};

export default EditAppointmentPage;
